import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateVehicleDto } from './create-vehicle.dto';

/**
 * Update vehicle DTO
 */
export class UpdateVehicleDto extends CreateVehicleDto {
	@TransformInt()
	id!: number;
}
